module.exports = __webpack_public_path__ + "img/microsoft-button.ad23a60a.svg";